export const userManagementList = [
  {
    title: "userManagement.users.title",
    description: "userManagement.users.description",
    imgUrl: "users",
    docsUrl: "userManagement.users.docsUrl"
  },
  {
    title: "userManagement.reports.title",
    description: "userManagement.reports.description",
    imgUrl: "reports",
    docsUrl: "userManagement.reports.docsUrl"
  },
  {
    title: "userManagement.billing.title",
    description: "userManagement.billing.description",
    imgUrl: "billing",
    docsUrl: "userManagement.billing.docsUrl"
  }
];
